import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IAddressesContextValue } from './types';

export default createContext<IAddressesContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
